var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-sticky',[(_vm.showHeader)?_c('Header',{key:_vm.$route.path,attrs:{"dark":_vm.headerDark,"showTextLabel":_vm.headerLabelVisible}}):_vm._e()],1),_c('router-view',{staticClass:"page_content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }